import {
    getFormQuestionSchema,
    getOptionsFromList,
} from '~/lib/Questions/Questions.utils';
import Questions from '~/lib/Questions';

export function getOptions(question, objectSchema) {
    const questionSchema = Questions[question.type];

    const formQuestionSchema = getFormQuestionSchema(question, objectSchema);

    if (Array.isArray(questionSchema?.options)) {
        return questionSchema.options;
    } else if (formQuestionSchema?.options?.length > 0) {
        return getOptionsFromList(formQuestionSchema?.options);
    } else {
        return [];
    }
}
